import { LitElement, html } from 'lit';
import { customElement, property } from 'lit/decorators.js';

import { render } from 'react-dom';
import * as React from 'react';
import { LINK_URL } from '../web-components/utils';
import {
    DeviceType,
    PageType,
    Subvertical,
    Vertical,
} from '../../../shared/types/ast';
import Horseshoe, { Props } from './horseshoe';
import { getConfig } from '../../config';
export const NAME = 'horseshoe-web-component';

function makeAdAvailableFromLightDOM(id, webComponentDefinition = NAME) {
    const slotDiv = document.createElement('div');
    slotDiv.slot = `${id}_slot`;
    slotDiv.id = id;

    const advtWebComponent = document.querySelector(webComponentDefinition);
    if (advtWebComponent) {
        advtWebComponent.appendChild(slotDiv);
    }
}

@customElement(NAME)
export class HorseshoeWebComponent extends LitElement {
    @property({ type: String })
    pageType: PageType = null;

    @property({ type: String })
    vertical: Vertical = null;
    deviceType: DeviceType = null;
    subvertical: Subvertical = null;

    constructor() {
        super();

        const config = getConfig();
        config.placements.forEach(({ placementId }) => {
            makeAdAvailableFromLightDOM(placementId);
        });
    }

    updated(_changedProperties) {
        super.updated(_changedProperties);

        const props = {
            pageType: this.pageType,
            vertical: this.vertical,
            deviceType: this.deviceType,
            subvertical: this.subvertical,
            slotAd: true,
        };

        this.renderReact(props);
    }

    renderReact(props: Props) {
        render(
            <Horseshoe {...props} />,
            this.shadowRoot.getElementById(`${NAME}-root`),
        );
    }

    render() {
        return html`
            <link href="${LINK_URL.FABRIC}" rel="stylesheet" />
            <link href=${LINK_URL.ADVT_CSS} rel="stylesheet" />
            <div id="${NAME}-root"></div>
            <!--            <script src="https://acdn.adnxs.com/ast/ast.js"-->
        `;
    }
}
